import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { Button } from 'src/shared/components/button';
import { FileUpload } from 'src/shared/components/fileUpload';
import Popover from 'src/shared/components/popover';
import { StringHelper } from 'src/shared/helpers/string';
import { BREAKPOINTS, useLayout } from 'src/shared/hooks/useLayout';
import { CoverInfo } from './coverInfo';
import { PopoverButton } from './popoverButton';
const fileDetails = {
    measures: {
        width: 1920,
        height: 1080
    },
    formats: ['jpg', 'jpeg', 'png']
};
export function UploadPopover({ appliedFile, selectedFile, entityType, onApply, onUploadEnd, onSelectFile, hideGalleryInfo = false }) {
    const { t } = useTranslation();
    const { product } = useHostContext();
    const { screenWidth } = useLayout();
    const popoverRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadAttemptKey, setUploadAttemptKey] = useState(StringHelper.generateUUID());
    function apply() {
        onApply();
        popoverRef.current?.closePopover();
        setUploadAttemptKey(StringHelper.generateUUID());
    }
    function cancel() {
        popoverRef.current?.closePopover();
        setIsLoading(false);
        setUploadAttemptKey(StringHelper.generateUUID());
        onSelectFile(appliedFile);
    }
    function uploadEnd(fileId) {
        setIsLoading(false);
        onUploadEnd?.(fileId);
    }
    return (_jsxs(Popover, { position: screenWidth <= BREAKPOINTS.lg ? 'bottom' : 'left', className: "absolute mt-2 w-full sm:w-[452px] lg:w-[96px] xl:w-[300px] min-[1400px]:w-[452px]", ref: popoverRef, children: [_jsx(PopoverButton, { action: appliedFile?.id ? 'change' : 'add' }), _jsxs(Popover.Body, { className: "w-screen sm:w-[452px]", children: [_jsx(FileUpload, { onEnd: uploadEnd, details: fileDetails, entityType: entityType, onSelectFile: onSelectFile, onStart: () => setIsLoading(true), uploadAttemptKey: uploadAttemptKey, fileName: selectedFile?.name ?? '' }), _jsx(CoverInfo, { enabled: !hideGalleryInfo &&
                            product.moduleDisplayType !== 'GALLERY' &&
                            Boolean(selectedFile?.name) }), _jsxs("div", { className: "mt-5 flex w-full gap-4", children: [_jsx(Button, { className: "w-full", variation: "secondary", onClick: cancel, children: t('general.cancel') }), _jsx(Button, { className: "w-full", disabled: isLoading, onClick: apply, children: t('general.apply') })] })] })] }));
}
